import { Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { wrapper } from './AboutSubscription.css';
import aboutImg from './aboutSubscription.png';

export const AboutSubscription = () => (
  <div className={wrapper}>
    <Typography variant="headline" size="large">
      Thinking about a Subscription?
    </Typography>
    <Col gap="xl">
      <Typography variant="body" size="large">
        The payoff may be larger, but so is your upfront investment. Only start
        with a Subscription if you are ready to create a few months worth of
        content.
      </Typography>
    </Col>
    <img src={aboutImg} />
  </div>
);
